import { HomeRouterLayout } from "@spa/app/layouts/HomeRouterLayout";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";

const PeoplePage = withSuspense(
  () => import("@dust-tt/front/components/pages/people/PeoplePage"),
  "PeoplePage"
);

const PeopleChatRedirect = withSuspense(
  () => import("@dust-tt/front/components/pages/people/PeopleChatRedirect"),
  "PeopleChatRedirect"
);

// People shares Home's providers: starting a conversation from the directory
// lands in the same conversation chrome the rest of Home links into.
export const peopleRoutes: RouteObject[] = [
  {
    element: <HomeRouterLayout />,
    children: [
      { path: "people", element: <PeoplePage /> },
      {
        path: "people/conversations/:userIds",
        element: <PeopleChatRedirect />,
      },
    ],
  },
];
